export default "__VITE_ASSET__d3ea5b5c__"